const handleFetchLedgerFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.ledger = action.payload.data;
    state.currentPage = action.payload.current_page;
    state.perPage = action.payload.limit;
    state.totalPages = action.payload.total_pages;
    state.totalLedger = action.payload.total_leave_history_count;
    state.lastUpdated = action.payload.last_updated;
    state.message = action.payload.message;
};

export {
    handleFetchLedgerFulfilled,
};
